import { SanityCreateShopPage } from '@data/sanity/queries/types/shop'
import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { Locale } from '@lib/language'
import { PrintShopFormContextProvider } from '@lib/print/print-shop-form-context'
import { CustomStaticPropsContext } from '@lib/routes'
import { getPreview } from '@lib/sanity/client'
import { getCreateShopPage } from '@lib/sanity/shop'

import Layout from '@components/layout'
import Modules from '@modules/modules'

interface CreateShopPageProps {
  locale: Locale
  page: SanityCreateShopPage
  site: SanitySiteFragment
}

const CreateShopPage = ({ page, site }: CreateShopPageProps) => {
  return (
    <PrintShopFormContextProvider
      printSlots={page.printSlots}
      printPermissions={page.printPermissionSettings.printPermissions}
    >
      <Layout page={page} site={site}>
        <Modules modules={page.modules} />
      </Layout>
    </PrintShopFormContextProvider>
  )
}

export async function getStaticProps({
  locale,
  preview,
  previewData,
}: CustomStaticPropsContext) {
  const createShopPage = await getCreateShopPage(
    locale,
    getPreview(preview, previewData),
  )

  return {
    props: {
      locale,
      page: createShopPage.page,
      site: createShopPage.site,
    },
    revalidate: 60,
  }
}

export default CreateShopPage
